import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FocusKeyManager } from '@angular/cdk/a11y';
import { ListButtonDirective } from '../../directives/list-button.directive';
import { FilterOption } from '@immosky/types';

@Component({
  selector: 'lib-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent implements AfterViewInit {
  focusKeyManager!: FocusKeyManager<ListButtonDirective>;

  @Input()
  options!: FilterOption[];

  @Input()
  currentOption!: FilterOption;

  @Input()
  highlightSelected = false;

  @Output()
  update = new EventEmitter<FilterOption>();

  @Output()
  tabOut = new EventEmitter<void>();

  @ViewChildren(ListButtonDirective)
  buttons!: QueryList<ListButtonDirective>;

  ngAfterViewInit(): void {
    this.focusKeyManager = new FocusKeyManager<ListButtonDirective>(
      this.buttons
    )
      .withWrap()
      .withHomeAndEnd()
      .withVerticalOrientation()
      .withHorizontalOrientation('ltr');

    this.focusKeyManager.tabOut.subscribe(() => {
      this.tabOut.emit();
    });

    window.requestAnimationFrame(() => {
      this.focusKeyManager.setActiveItem(this.getIndexOfCurrentOption());
    });
  }

  select(option: FilterOption) {
    this.update.emit(option);
  }

  onKeydown(event: KeyboardEvent) {
    this.focusKeyManager.onKeydown(event);
  }

  private getIndexOfCurrentOption(): number {
    if (this.currentOption) {
      return this.options.indexOf(this.currentOption);
    }
    return 0;
  }

  trackBy(index: number, option: FilterOption) {
    return option.value;
  }

  focusButton(i: number) {
    this.focusKeyManager.setActiveItem(i);
  }
}
